import React from 'react';
import styled from "styled-components";
import { Radar, RadarChart, PolarGrid, ResponsiveContainer, PolarAngleAxis, PolarRadiusAxis} from 'recharts';

const RadarCharts = (props) => {
    const {data, isBlur} = props;
    return (
        <Container sBlur={isBlur}>    
            <ResponsiveContainer>
                <RadarChart cx={'50%'} cy={'50%'} outerRadius={'60%'} data={data}>
                    <PolarGrid />
                    <PolarAngleAxis dataKey="subject" />
                    <PolarRadiusAxis angle={18} />
                    <Radar dataKey="data" stroke="palevioletred" fill="rgba(222, 6, 6, 0.5)" fillOpacity={0.6} />
                </RadarChart>               
            </ResponsiveContainer>      
        </Container>
    );
}
export default RadarCharts;

const Container = styled.div`
    width: 100%;
    height: 100%;
    overflow: scroll;
    ${({ isBlur }) => isBlur ? 'filter: blur(5px)' : ''};
`

// class RadarCharts extends Component {
//     render() {
//         const dataFirst = [
//             { subject: '日常', A: 100, B: 10, },
//             { subject: '擺地攤', A: 98, B: 13, },
//             { subject: '出國炫富', A: 86, B: 13, },
//             { subject: '整老婆', A: 99, B: 100, },
//             { subject: 'bang', A: 85, B: 90, },
//         ];
//         const dataSecond = [
//             { subject: '日常', A: 100, B: 10, },
//             { subject: '擺地攤', A: 98, B: 13, },
//             { subject: '出國炫富', A: 86, B: 13, },
//             { subject: '整老婆', A: 99, B: 100, },
//             { subject: 'bang', A: 85, B: 90, },
//         ]
//         let data = this.props.data;
//         return (
//             <div style={{ width: '100%', height: '100%' }}>    
//                 <ResponsiveContainer>
//                     <RadarChart cx={'50%'} cy={'50%'} outerRadius={'60%'} data={dataFirst}>
//                         <PolarGrid />
//                         <PolarAngleAxis dataKey="subject" />
//                         <PolarRadiusAxis angle={18} />
//                         <Radar dataKey="A" stroke="	palevioletred" fill="rgba(222, 6, 6, 0.5)" fillOpacity={0.6} />
//                     </RadarChart>               
//                 </ResponsiveContainer>      
//             </div>
//         );
//     }
// }


// WEBPACK FOOTER //
// ./src/Info/Creator/RadarChart.js